/**
 * Gets the payload from a JWT
 * @param {string} jwt 
 * @returns JWT payload object
 */
export function getJwtPayload(jwt) {
    const parts = jwt.split(".");
    if (parts.length < 3) throw new Error("Not a valid JWT");
    const string = atob(parts[1]);
    const payload = JSON.parse(string);
    return payload;
}